import React, {
  FunctionComponent,
  ReactElement,
  useEffect,
  useState
} from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import {
  Button,
  Dialog,
  Icon,
} from '@blueprintjs/core';
import { RootState } from 'data/root.reducers';
import * as authenticationSelectors from 'data/authentication/authentication.selectors';
// import * as authenticationActions from 'data/authentication/authentication.actions';
import './lockout-notification.scss';

const mapState = (state: RootState) => ({
  isAuthenticated: authenticationSelectors.getShowT1LockoutVisualIndicator(state),
  showT1LockoutVisualIndicator: authenticationSelectors.getShowT1LockoutVisualIndicator(state),
});

const mapDispatch = {};

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>;

export type Props = PropsFromRedux;

export const LockoutNotification: FunctionComponent<Props> = ({
  isAuthenticated,
  showT1LockoutVisualIndicator,
}: Props): ReactElement | null => {
  const { t } = useTranslation();

  const [showAlert, setShowAlert] = useState(showT1LockoutVisualIndicator);

  useEffect(() => {
    setShowAlert(showT1LockoutVisualIndicator);
  }, [showT1LockoutVisualIndicator]);

  const handleClose = () => {
    setShowAlert(false)
  }

  if (!isAuthenticated || !showT1LockoutVisualIndicator) {
    return null;
  }

  return (
    <Dialog
      isOpen={showAlert}
      isCloseButtonShown={false}
      className="lockout-notification"
    >
      <div className="lockout-notification-alert">
        <Icon icon="issue" className="lockout-notification-icon" />
        <div className="lockout-notification-label">
          {t('login.team.lockout')}
        </div>
        <Button text={t('common.button.ok')} className="lockout-notification-action" onClick={handleClose} />
      </div>
    </Dialog>
  );
};

export default withRouter(connector(LockoutNotification));
